export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "skip-to-content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skip to content"])}
      },
      "fr": {
        "skip-to-content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aller au contenu"])}
      }
    }
  })
}
